import { Injectable } from '@angular/core';

import { FsMapGeometryServiceProvider } from '@lib/geo/core';
import { EsriMap } from '@lib/geo/esri';
import { FsMap } from '@lib/geo/map';

import { EsriBoundsManagementService } from '../services/esri/esri-bounds-management.service';
import { EsriGeometricNavigationService } from '../services/esri/esri-geometric-navigation.service';
import { EsriZoomManagementService } from '../services/esri/esri-zoom-management.service';

@Injectable({
  providedIn: 'root',
})
export class EsriMapGeometryProvider extends FsMapGeometryServiceProvider<EsriMap> {
  constructor(
    private boundsService: EsriBoundsManagementService,
    private zoomService: EsriZoomManagementService,
    private navigationService: EsriGeometricNavigationService,
  ) {
    super();
  }

  get geospatialProvider(): string {
    return 'esri';
  }

  get id(): string {
    return 'esri-map-geometry-provider';
  }

  get bounds() {
    return this.boundsService;
  }

  get zoom() {
    return this.zoomService;
  }

  get navigation() {
    return this.navigationService;
  }

  public setMap(map: EsriMap) {
    this.boundsService.setMap(map);
    this.zoomService.setMap(map);
    this.navigationService.setMap(map);
  }
}
